React = require 'react'
t = require('views/internal/recup-with-helpers')('org_members')

module.exports = class OrganizationMembersSidebarComponent extends React.Component

  constructor: (props) ->
    super
    @state =
      showingAll: false

  render: t.renderable ->
    { canManageMembers, canLinkGoogleApps, canShowAll, onLinkGoogleApps, openManageMembers, openBulkAdd, filter, onFilterChange, onShowAllChange } = @props
    { showingAll } = @state

    toggleShowingAll = =>
      showingAll = !@state.showingAll
      @setState( { showingAll })
      onShowAllChange(showingAll)

    t.div ->
      t.div '.org-members-page-navigation-list', ->
        t.div '.org-members-options', ->
          t.div '.org-members-page-navigation-list-header', ->
            t.format 'search-team'
          t.hr()
          t.input '.org-members-page-navigation-input',
            style: { marginBottom: 50 }
            type: 'text'
            placeholder: t.l 'find-members-by-name-ellipsis'
            value: filter
            onChange: (e) ->
              onFilterChange(e.target.value)

          if canManageMembers
            t.div '.org-members-page-navigation-list-header', ->
              t.format 'add-members'
            t.hr()

            t.b openManageMembers, { class: 'primary button-link autowrap' }, ->
              t.icon 'member', 'add-by-name-or-email'

            t.b openBulkAdd, { class: 'button-link autowrap' }, ->
              t.icon 'member', 'add-a-list-of-emails-or-usernames'

          if canLinkGoogleApps
            t.div ->
              t.b onLinkGoogleApps, { class: 'button-link' },  ->
                t.icon 'google', 'link-google-apps-domain'

          if canShowAll
            t.b toggleShowingAll, '.quiet-button', ->
              t.format if showingAll then 'hide-dismissed' else 'show-dismissed-accounts'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-members-sidebar-component.coffee